export const PAGE_NAME_MAPPING = {
  dashboard: 'Dashboard',
  advertisers: 'Advertisers',
  advertiserView: 'Advertiser View',
  editAdvertiser: 'Edit Advertiser',
  createAdvertiser: 'Create Advertiser',
  advertiserUsersList: "List Advertiser's Users",
  creators: 'Creators',
  editCreator: 'Edit Creator',
  createCreator: 'Create Creator',
  clients: 'Clients',
  createClient: 'Create Client',
  editClient: 'Edit Client',
  links: "Creator's link list",
  campaigns: 'Campaigns',
  contentLibrary: 'Content Library',
  payments: 'Payments',
  doPayment: 'Do Payment',
  advertiserInvoicePayments: 'Advertiser Invoice Payments',
  clientInvoicePayments: 'Client Invoice Payments',
  reports: 'Reports',
  returnAds: 'Return ads',
  marketingNotifications: 'Marketing notifications',
  login: 'Login',
  logout: 'Logout',
  powerBi: 'Power Bi',
  documentation: 'Documentation',
  segments: 'Segments',
}
